/* keyedalike.com — the homepage yard (sections/ka-yard.liquid): pairs each balloon on the plan with its schedule row.
   Hover or focus on either marks both (.is-on, matched by data-n within one section). A balloon's click marks its row
   and brings it into view: sideways on the phone rail (760px and below, where the rows scroll) and down the page when
   the row is off screen; smooth unless the visitor asks for reduced motion. Without this file the balloons are plain
   links to their rows (#yard-row-N-<section id>) and :target marks the row, so the section works without it.
   Idempotent: the section prints this tag once per copy, but only the first copy runs (window.kaYard); every .yard
   is set up once (data-yard-ready), and a section the theme editor re-renders is set up again (shopify:section:load). */
(() => {
  if (window.kaYard) return;
  window.kaYard = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setUp = (yard) => {
    if (yard.dataset.yardReady) return;
    yard.dataset.yardReady = 'true';
    const items = [...yard.querySelectorAll('[data-n]')];
    const mark = (n) => {
      items.forEach((item) => item.classList.toggle('is-on', n !== null && item.dataset.n === n));
    };

    items.forEach((item) => {
      const n = item.dataset.n;
      item.addEventListener('mouseenter', () => mark(n));
      item.addEventListener('mouseleave', () => mark(null));
      item.addEventListener('focusin', () => mark(n));
      item.addEventListener('focusout', () => mark(null));
    });

    yard.querySelectorAll('a.pin').forEach((pin) => {
      pin.addEventListener('click', (event) => {
        const id = (pin.getAttribute('href') || '').slice(1);
        const row = id ? document.getElementById(id) : null;
        if (!row || !yard.contains(row)) return;
        event.preventDefault();
        mark(pin.dataset.n);
        const behavior = reduce.matches ? 'auto' : 'smooth';
        const rail = row.parentElement;
        if (rail.scrollWidth > rail.clientWidth + 1) {
          rail.scrollTo({ left: row.offsetLeft - rail.firstElementChild.offsetLeft, behavior });
        }
        const box = row.getBoundingClientRect();
        if (box.top < 0 || box.bottom > window.innerHeight) {
          row.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior });
        }
      });
    });
  };

  const setUpAll = (root) => {
    if (root instanceof Element && root.matches('.yard')) setUp(root);
    root.querySelectorAll('.yard').forEach(setUp);
  };
  setUpAll(document);
  document.addEventListener('shopify:section:load', (event) => setUpAll(event.target));
})();
